<template>
  <div class="modal">
    <b-modal
      :id="'show-modal-update-limit' + index"
      ref="showModalLimitHolder"
      size="lg"
      class="mt-4"
      @hidden="closeModal"
      hide-footer
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
    >
      <template #modal-title>
        <h5 class="modal-title">Buscar limites via api:</h5>
      </template>
      <div
        v-if="loading"
        class="overlay d-flex align-items-center justify-content-center"
      >
        <div class="d-flex justify-content-center mb-2">
          <b-spinner label="Loading..."></b-spinner>
        </div>
      </div>
      
      <p v-if="index>=0"><strong>{{ economicGroup.group_name ?? '' }}</strong></p>

      <div class="row">
        <div class="col-md-4"
          v-for="insurer in insurerList"
          :key="insurer.identifier">
          
        <label
          class="card card-body border shadow p-3 d-block mb-2 mr-2">
          <div class="row">
            <div class="col-md-8 align-self-center">
              <div class="logo-seguradora-limite" :style="{ backgroundImage: 'url(' + insurer.icon + ')' }"></div>
            </div>
            <div class="col-md-4 align-self-center text-center">
              <b-spinner v-if="insurer.loading" class="spinner-border-sm"></b-spinner>
              <i class="fa-solid fa-triangle-exclamation text-warning msg_icon"
                v-b-tooltip.hover
                v-if="insurer.error" :title="insurer.error"></i>
              <i class="fa-solid fa-circle-check text-success msg_icon"
                v-b-tooltip.hover
                v-if="insurer.success" :title="insurer.success"></i>
            </div>
          </div>
        </label>
          
        </div>
      </div>
      
      <div class="d-flex align-items-center justify-content-between  mt-3">
          <button class="btn btn-primary float-left"
            :disabled="runningRequests"
            @click="startFindLimits()">
            Iniciar
          </button>
          <small class="mx-auto" v-if="runningRequests">
            Aguarde finalizar a busca.
            <b-spinner small class="ml-2" label="Loading..."></b-spinner>
          </small>
          <button class="btn btn-primary float-right"
            :disabled="runningRequests"
            @click="closeModal()">
            Fechar
          </button>
      </div>

    </b-modal>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import commomsHelperMixin from "@/mixins/commomsHelper";
import commonsService from "@/services/commons";
import companyService from "@/services/company";

export default {
  name: "UpdateLimitHolderModal",
  emits: ["getInsurerLimit"],
  data: () => ({
    loading: false,    
    insurerList: [],
    qtdRequestOpen: 0,
    qtdRequestConcluded: 0
  }),
  props: {
    economicGroup: {
      type: Object,
      required: true,
    },
    index: Number,
  },
  mixins: [commomsHelperMixin],
  components: {
  },
  directives: {
    mask,
  },
  created() {
    // TODO: Se o componente é chamado mais de 1x, repete getAllInsurersWithIntegration
    this.getAllInsurersWithIntegration();
  },
  methods: {
    startFindLimits() {
      this.loading = true;
      this.qtdRequestOpen = 0;
      this.qtdRequestConcluded = 0;

      this.insurerList.forEach((item, key) => {
        this.clearItemCard(key);
        this.$set(this.insurerList[key], 'loading', true);
        this.qtdRequestOpen++;
        companyService.updateLimitEconomicGroup(this.economicGroup.id, item.identifier)
          .then((response) => {
            if (response.data.error) {
              return;
            }
            this.$set(this.insurerList[key], 'success', 'Busca concluída.');
          })
          .catch((err) => {
            this.$set(this.insurerList[key], 'error', 'Não foi possível buscar.');
            if (err.response.data && err.response.data.message) {
              this.$set(this.insurerList[key], 'error', err.response.data.message);
            }
          })
          .finally(() => {
            this.$set(this.insurerList[key], 'loading', false);
            this.qtdRequestConcluded++;
          });
      });

      this.loading = false;
    },
    closeModal() {
      if (!this.runningRequests) {
        this.clearCards();
        this.getInsurerLimit();
        if (this.$refs.showModalLimitHolder) {
          this.$refs.showModalLimitHolder.hide();
        }
      }
    },
    clearCards() {
      this.insurerList.forEach((item, key) => {
        this.clearItemCard(key);
      });
    },
    clearItemCard(key) {
      this.$set(this.insurerList[key], 'error', '');
      this.$set(this.insurerList[key], 'loading', false);
      this.$set(this.insurerList[key], 'success', false);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getAllInsurersWithIntegration() {
      this.loading = true;
      commonsService
        .getAllInsurersWithIntegration()
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.insurerList = response.data;
        })
        .catch((error) => {
          this.showError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getInsurerLimit() {
      this.$emit("getInsurerLimit");
    },
  },
  computed: {
    runningRequests() {
      return this.qtdRequestOpen == 0 ? false :
        this.qtdRequestConcluded != this.qtdRequestOpen;
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent) => {
      if (bvEvent.componentId == 'show-modal-update-limit' + this.index) {
        this.startFindLimits();
      }
    });
  }
};
</script>

<style scoped>
.card { height: 90%; }
.card .msg_icon { font-size: 20px; }
</style>
